module.exports = __webpack_public_path__ + "static/media/yellowcherry.d918fc98.webp";